module.exports = __webpack_public_path__ + "static/media/metalab-interdisciplinary@2x.e8fe17f5.png";